export default __webpack_public_path__ + "i18n/es.9754127192e6f5e4cd8bb40794256209.json";